// extracted by mini-css-extract-plugin
export default {"parent":"card_parent__v-SGB","contenir":"card_contenir__g47Rk"};